export default __webpack_public_path__ + "static/media/gallery_4.da90359a.jpeg";